export default function Delivery() {
  return (
    <section id="delivery" className="py-24 px-6 lg:px-20 bg-[#E63946]">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Content */}
          <div>
            <div className="inline-block bg-white/20 px-4 py-2 rounded-full mb-6">
              <p className="text-white font-semibold text-sm">HAZ TU PEDIDO</p>
            </div>
            
            <h2 className="text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
              Servicio a <span className="text-white">Domicilio Gratis</span>
            </h2>
            
            <p className="text-xl text-white/90 leading-relaxed mb-8">
              Haz tu pedido por teléfono o WhatsApp y recógelo en nuestro local o recíbelo en tu casa. Rápido, fácil y con la mejor calidad de siempre.
            </p>

            {/* Features */}
            <div className="space-y-6 mb-10">
              <div className="flex items-start gap-4">
                <div className="w-14 h-14 bg-white/20 backdrop-blur-sm rounded-2xl flex items-center justify-center flex-shrink-0">
                  <i className="ri-phone-line text-white text-2xl"></i>
                </div>
                <div>
                  <h4 className="text-xl font-bold text-white mb-1">Pedido Fácil</h4>
                  <p className="text-white/90">Llama o escríbenos por WhatsApp</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-14 h-14 bg-[#25D366] rounded-2xl flex items-center justify-center flex-shrink-0">
                  <i className="ri-whatsapp-line text-white text-2xl"></i>
                </div>
                <div>
                  <h4 className="text-xl font-bold text-white mb-1">WhatsApp</h4>
                  <p className="text-white/90">Pide por WhatsApp: 643 383 317</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-14 h-14 bg-white/20 backdrop-blur-sm rounded-2xl flex items-center justify-center flex-shrink-0">
                  <i className="ri-e-bike-2-line text-white text-2xl"></i>
                </div>
                <div>
                  <h4 className="text-xl font-bold text-white mb-1">Envío Gratis</h4>
                  <p className="text-white/90">Servicio a domicilio sin coste adicional</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-14 h-14 bg-gray-900 rounded-2xl flex items-center justify-center flex-shrink-0">
                  <i className="ri-bank-card-line text-white text-2xl"></i>
                </div>
                <div>
                  <h4 className="text-xl font-bold text-white mb-1">Aceptamos Visa</h4>
                  <p className="text-white/90">Pago en efectivo o con tarjeta</p>
                </div>
              </div>
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-wrap gap-4">
              <a
                href="tel:919123048"
                className="inline-flex items-center gap-3 bg-gray-900 text-white px-8 py-4 rounded-full text-lg font-bold hover:bg-gray-800 transition-all hover:scale-105 shadow-xl whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-fill text-xl"></i>
                919 123 048
              </a>
              <a
                href="https://wa.me/34643383317"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-3 bg-[#25D366] text-white px-8 py-4 rounded-full text-lg font-bold hover:bg-[#20BA5A] transition-all hover:scale-105 shadow-xl whitespace-nowrap cursor-pointer"
              >
                <i className="ri-whatsapp-fill text-xl"></i>
                643 383 317
              </a>
            </div>
          </div>

          {/* Image */}
          <div className="relative h-[600px] rounded-[32px] overflow-hidden">
            <img
              src="https://public.readdy.ai/ai/img_res/73092d5be275ac27add2d1ad1e8755b8.jpg"
              alt="Servicio a Domicilio Gratis"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>

        {/* Delivery Zones */}
        <div className="mt-16 bg-white/10 backdrop-blur-sm rounded-3xl p-8">
          <h3 className="text-2xl font-bold text-white mb-6 text-center">Zonas de Reparto - Pedido Mínimo</h3>
          <div className="grid md:grid-cols-4 gap-6">
            <div className="text-center">
              <div className="w-16 h-16 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center mx-auto mb-3">
                <i className="ri-map-pin-line text-white text-2xl"></i>
              </div>
              <h4 className="font-bold text-white mb-1">Pozuelo</h4>
              <p className="text-white font-bold text-xl">10€</p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center mx-auto mb-3">
                <i className="ri-map-pin-line text-white text-2xl"></i>
              </div>
              <h4 className="font-bold text-white mb-1">Cabaña</h4>
              <p className="text-white font-bold text-xl">15€</p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center mx-auto mb-3">
                <i className="ri-map-pin-line text-white text-2xl"></i>
              </div>
              <h4 className="font-bold text-white mb-1">Somosaguas</h4>
              <p className="text-white font-bold text-xl">15€</p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center mx-auto mb-3">
                <i className="ri-map-pin-line text-white text-2xl"></i>
              </div>
              <h4 className="font-bold text-white mb-1">Aravaca</h4>
              <p className="text-white font-bold text-xl">20€</p>
            </div>
          </div>
        </div>

        {/* Info Cards */}
        <div className="grid md:grid-cols-3 gap-8 mt-12">
          <div className="bg-white/10 backdrop-blur-sm rounded-3xl p-8 text-center">
            <div className="w-20 h-20 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-restaurant-line text-white text-3xl"></i>
            </div>
            <h4 className="text-xl font-bold text-white mb-2">Salón Interior</h4>
            <p className="text-white/90">Disponemos de salón para celebraciones</p>
          </div>

          <div className="bg-white/10 backdrop-blur-sm rounded-3xl p-8 text-center">
            <div className="w-20 h-20 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-phone-line text-white text-3xl"></i>
            </div>
            <h4 className="text-xl font-bold text-white mb-2">Teléfono</h4>
            <p className="text-white/90">919 123 048</p>
          </div>

          <div className="bg-white/10 backdrop-blur-sm rounded-3xl p-8 text-center">
            <div className="w-20 h-20 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-calendar-line text-white text-3xl"></i>
            </div>
            <h4 className="text-xl font-bold text-white mb-2">Horario</h4>
            <p className="text-white/90">12:00-16:00 / 19:00-24:00</p>
          </div>
        </div>
      </div>
    </section>
  );
}